module.exports = __webpack_public_path__ + "img/audio.d142259c.svg";